
      const jsUrl = "https://static.idp.sph.com.sg/mySPH-lightbox/4.x.x/js/mySPH.js";
      if (jsUrl && jsUrl.indexOf("%") === -1) {
        const script = document.createElement("script");
        script.type = "module";
        script.src = jsUrl;
        document.head.appendChild(script);
      }
    